import { article, IArticle } from '../services/article';
import createSliceState from './common/createSliceState';
// todo import { history } from '../utils/history';
import { AdvancedType, BasicType, BlockManager, IBlockData } from '../../core';
import { IEmailTemplate } from '../../editor';
import services from '../services';

export function getAdaptor(data: IArticle): IEmailTemplate {
    const content = JSON.parse(data.json) as IBlockData;
    return {
        ...data,
        content,
        subject: data.subject,
        subTitle: data.subTitle,
    };
}

export default createSliceState({
    name: 'template',
    initialState: null as IEmailTemplate | null,
    reducers: {
        set: (state, action) => {
            return action.payload;
        },
    },
    effects: {
        fetchById: async (
            state,
            {
                id,
            }: {
                id: number | string;
            },
        ) => {
            try {

                let data = await article.getArticle(id);

                return getAdaptor(data);
            } catch (error) {
                // todo history.replace('/');
                throw error;
            }
        }, updateById: async (
            state,
            payload: {
                id: number | string;
                template: IEmailTemplate;
                success: (templateId: number | string, savedTemplate: IEmailTemplate) => void;
                error: (templateId: number | string, error: unknown) => void;
                json: string;
                mjmlString: string;
                html: string;
                previewImage: string;
            },
        ) => {
            try {
                const response = await services.article.updateArticle(payload.id, {
                    revision: payload.template.revision,
                    subject: payload.template.subject,
                    subtitle: payload.template.subTitle,
                    json: payload.json,
                    mjml: payload.mjmlString,
                    html: payload.html,
                    previewImage: payload.previewImage
                });
                // Campaign saves return the exact revision just committed. Do not
                // fetch a newer, possibly unrelated edit and adopt its revision.
                // Operational template saves return 204 and still need a reload.
                const savedTemplate = getAdaptor(response || await article.getArticle(payload.id));
                payload.success(payload.id, savedTemplate);
                return savedTemplate;
            } catch (error: any) {
                payload.error(payload.id, error);
            }
        },
        fetchDefaultTemplate: async state => {
            return {
                subject: 'Welcome',
                subTitle: 'Nice to meet you!',
                content: BlockManager.getBlockByType(BasicType.PAGE).create({
                    children: [BlockManager.getBlockByType(AdvancedType.WRAPPER).create()],
                }),
            } as IEmailTemplate;
        },
    },
});
